export default [
  'Reclutamiento tradicional',
  'Reclutamiento alternativo',
  'Ambos'
]